<template>
  <div id="software">
    <div class="text">
      <h2>一、行业痛点</h2>
      <p>
        <strong>1. 数据要素沉睡。</strong>医疗健康数据分散于异构系统，电子病历未做标准化治理，数据不真实、不连续、不完整，价值难以释放。
      </p>
      <p>
        <strong>2. 服务效率低下。</strong>医生无法精准识别和管理患者，个人价值难以向院外延伸；患者缺乏日常医学指导，机构运营持续承压。
      </p>
      <p>
        <strong>3. 服务边界受限。</strong>与基层机构仅有医联体协议而无实质业务协同，分级诊疗与双向转诊难以落地，优势科室无法向外导流。
      </p>

      <h2>二、解决思路：新质服务模型</h2>
      <p>
        以新质服务模型重构服务链条，推动医疗服务由院内走向院外、由治疗延伸至预防与康复。
      </p>

      <h3>（一）智能一站式就诊——破解就医流程低效</h3>
      <p>
        AI 分析预问诊报告生成“就诊指引单”，就诊前锁定车位、智能导航、自动签到叫号；检查环节按排队人数智能排序，报告自动复查排队、自助取药、AI 随访；未出报告可线上复诊并配送药品。
      </p>
      <!-- <figure class="figure">
        <img
          src="@/assets/images/20250724/ruanjian/jiuyi1.svg"
          alt="智能一站式就诊服务流程图：从预问诊、预约车位到自动签到、智能排队、自助取药"
          loading="lazy"
        />
        <figcaption>智能一站式就诊服务流程</figcaption>
      </figure> -->

      <h3>（二）全程陪诊——延伸院外服务能力</h3>
      <p>
        依托服务标签帮助机构识别重点服务对象，提升健康宣教与康复服务的触达效率；并围绕上述对象提供上门接送、预约号源、辅助问诊、指引检查、代排队取药等全流程陪护。
      </p>
      <!-- <figure class="figure">
        <img
          src="@/assets/images/20250724/ruanjian/jiuyi2.png"
          alt="全程陪诊服务内容图：上门接送、预约号源、辅助问诊、指引检查、排队取药"
          loading="lazy"
        />
        <figcaption>全程陪诊服务内容</figcaption>
      </figure> -->

      <h3>（三）预防+主动健康+康复护理——补足日常健康服务缺口</h3>
      <p>
        <strong>治未病：</strong>按病种定制健康宣教内容，短视频平台推广，结合用户画像提升宣教触达效率。
      </p>
      <p>
        <strong>健康管理：</strong>慢病患者签约医生，风险筛查形成“健康计划”，可穿戴设备监测预警，定期推送宣教与随访问卷，院外数据回写病历，支撑临床科研与药品研发。
      </p>
      <p>
        <strong>术后康复：</strong>出院患者签约护士，分组定制康复计划，上门提供管道护理、伤口造口、母婴护理等专业服务，形成完整康复路径。
      </p>
      <!-- <figure class="figure">
        <img
          src="@/assets/images/20250724/ruanjian/jiuyi3.png"
          alt="预防+主动健康+康复护理运营体系图：治未病、健康管理、术后康复三大板块"
          loading="lazy"
        />
        <figcaption>预防+主动健康+康复护理运营体系</figcaption>
      </figure> -->

      <h3>（四）分级诊疗与院内外导流——打破机构服务壁垒</h3>
      <p>
        整合区域医疗资源形成医联体双向导流，提升资源利用效率，推动分级诊疗落地，增强医院核心竞争力。
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "software",
  data() {
    return {};
  },
};
</script>
<style scoped>
.text {
  line-height: 24px;
  font-weight: 500;
  color: #666;
  margin-top: 30px;
  margin-right: 20px;
  text-indent: 28px;
}
.text h2 {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  text-indent: 0;
  margin: 30px 0 12px;
}
.text h3 {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  text-indent: 0;
  margin: 26px 0 10px;
}
.text h2:first-child {
  margin-top: 0;
}
.figure {
  margin: 24px 0 30px;
  text-align: center;
  text-indent: 0;
}
.figure img {
  width: 80%;
  height: auto;
}
.figure figcaption {
  margin-top: 10px;
  font-size: 13px;
  font-weight: 400;
  color: #999;
  text-indent: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/Solution1.vue